import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["useOnePassVariant", "widgetLayoutProps"];
import React, { forwardRef } from "react";
import { UpsellCTAWidgetZone } from "../../layouts/CTAWidgetLayout/CTAWidgetLayout";
import { OnePassFreeDeliveryVariant } from "./OnePassFreeDeliveryVariant";
import { UnpaidFreeDeliveryVariant } from "./UnpaidFreeDeliveryVariant";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellCTAWidget = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$useOnePassVarian = _ref.useOnePassVariant,
      useOnePassVariant = _ref$useOnePassVarian === void 0 ? true : _ref$useOnePassVarian,
      widgetLayoutProps = _ref.widgetLayoutProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(UpsellCTAWidgetZone, _extends({
    ref: ref
  }, widgetLayoutProps), useOnePassVariant ? ___EmotionJSX(OnePassFreeDeliveryVariant, props) : ___EmotionJSX(UnpaidFreeDeliveryVariant, props));
});
UpsellCTAWidget.displayName = "UpsellCTAWidget";